const state = {
  homeMsgExit:false,
  messageNum: 0,
  downloadNum: 0,
  uploadNum: 0

}

const mutations = {
  addDownloadFile: function (state) {
    state.messageNum++
    state.downloadNum++
  },

  addUploadFile: function (state) {
    state.messageNum++
    state.uploadNum++
  }
}

const actions = {
  someAsyncTask({commit}) {
    // do something async
    commit('INCREMENT_MAIN_COUNTER')
  }
}

export default {
  state,
  mutations,
  actions
}
